import { z } from "zod";

import { Role } from "~/shared/constants/roles.ts";

export const traxUserSchema = z.object({
	userId: z.string(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	email: z.string(),
	role: z.string(),
	roleId: z.number().optional(),
	mobilePhoneNumber: z.string().optional(),
	rowId: z.number().optional(),
	isMfaEnabled: z.boolean().optional(),
});

export type TraxUser = z.infer<typeof traxUserSchema>;

export const traxUserListSchema = z.array(traxUserSchema);

export const ROLE_OPTIONS = [
	{ displayText: "(select)", value: "" },
	{ displayText: "Admin", value: Role.Admin },
	{ displayText: "Operations", value: Role.Operations },
	{ displayText: "Finance", value: Role.Finance },
	{ displayText: "Reporting", value: Role.Reporting },
] as const;

export function getRoleId(role: string): number {
	switch (role.toLowerCase()) {
		case "admin": {
			return 1;
		}
		case "finance": {
			return 2;
		}
		case "reporting": {
			return 3;
		}
		case "operations": {
			return 4;
		}
		case "vendor": {
			return 5;
		}
		default: {
			return 0;
		}
	}
}

export function getAllowedRoles(currentUserRole: string): string[] {
	switch (currentUserRole.toLowerCase()) {
		case "admin":
		case "operations": {
			return ROLE_OPTIONS.filter((o) => o.value !== "").map((o) => o.value);
		}
		case "finance": {
			return [Role.Finance];
		}
		case "reporting": {
			return [Role.Reporting];
		}
		default: {
			return [];
		}
	}
}
